import React, { useEffect, useState } from 'react';
import { Card, Button, Pagination, Spinner } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import { toTitleCase } from '../utils/myFunctions';
import { IMAGE_BASE_URL } from '../constants/paths';


const ChurchVolunteerOpportunities = () => {
  const [opportunities, setOpportunities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const opportunitiesPerPage = 6;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const church = JSON.parse(localStorage.getItem('church') || 'null');

  useEffect(() => {
    const fetchOpportunities = async () => {
      try {
        setIsLoading(true);
        const res = await makeGetRequest(`volunteer-opportunities/${church.id}`);
        const pendingOnly = res.data?.filter((opp) => opp.status === 'open') || [];
        setOpportunities(pendingOnly);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        setError('Failed to fetch opportunities. Please try again later.');
        console.error(err);
      }
    };

    fetchOpportunities();
  }, [church.id]);

  const indexOfLast = currentPage * opportunitiesPerPage;
  const indexOfFirst = indexOfLast - opportunitiesPerPage;
  const currentOpportunities = opportunities.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(opportunities.length / opportunitiesPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  if(!opportunities) return null;

  return (
    <div className="container mt-4">
      <h3 className="mb-4 text-center">Volunteer Opportunities</h3>

      {isLoading && (
        <div className="text-center">
          <Spinner animation="border" />
        </div>
      )}

      {error && <p className="text-danger text-center">{error}</p>}

      {opportunities.length === 0 && !isLoading ? (
        <p className="text-center text-muted">No open volunteer opportunities at the moment.</p>
      ) : (
        <div className="row">
          {currentOpportunities.map((opp) => (
            <div className="col-md-6 mb-4" key={opp.id}>
              <Card className="shadow-sm h-100">
                {opp.image && (
                  <Card.Img
                    variant="top"
                    src={`${IMAGE_BASE_URL}${opp.image}`}
                    alt={opp.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                     crossorigin="anonymous"
                  />
                )}
                                  <p>{opp.image}</p>

                <Card.Body>
                  <Card.Title>{opp.title}</Card.Title>
                  <Card.Text>{opp.detail}</Card.Text>
                  <p><strong>Start:</strong> {opp.start_date}</p>
                  <p><strong>End:</strong> {opp.end_date}</p>
                  <p><strong>Skills:</strong></p>
                  {opp.skills?.length > 0 ? (
                    <ul>
                      {opp.skills.map((skill) => (
                        <li key={skill.id}>{toTitleCase(skill.skill)}</li>
                      ))}
                    </ul>
                  ) : (
                    <p className="text-muted">No special skills required</p>
                  )}
                  <Button
                    variant="primary"
                    href={`/${church.website}/contact-us`}
                    className="mt-2"
                  >
                    Contact Us
                  </Button>
                </Card.Body>
              </Card>
            </div>
          ))}
        </div>
      )}

      {/* Pagination */}
      {opportunities.length > opportunitiesPerPage && (
        <Pagination className="justify-content-center mt-4">
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
        </Pagination>
      )}
    </div>
  );
};

export default ChurchVolunteerOpportunities;
